<template>
  <div class="rounded-xs border border-gray-400 bg-gray-100 p-4">
    <slot />
  </div>
</template>
